import { handleCreateNewChat, setCurrectChat } from "../redux/admin-slices/socket.slice"
import { useDispatch, useSelector } from "react-redux"

const useChatInitiater = () => {
  const dispatch = useDispatch()
  const { chat, socket } = useSelector((state) => state.socketSlice)

  const initiateGeneralChat = async ({ receiver, sender }) => {
    try {
      const { chat } = await dispatch(
        handleCreateNewChat({
          sender,
          receiver,
          type: "general",
        })
      ).unwrap() || {}

      if (chat) {
        dispatch(setCurrectChat(chat))
        socket.emit("join-room", chat?._id)
      }

      return chat
    } catch (error) {
      console.error("Error initiating general chat:", error)
    }
  }

  const initiateAppointmentChat = async ({ appointmentId, receiver, sender }) => {
    try {
      const { chat } = await dispatch(
        handleCreateNewChat({
          sender,
          receiver,
          appointmentId,
          type: "appointment",
        })
      ).unwrap() || {}

      if (chat) {
        dispatch(setCurrectChat(chat))
        socket.emit("join-room", chat?._id)
      }

      return chat
    } catch (error) {
      console.error("Error initiating appointment chat:", error)
    }
  }

  return {
    initiateGeneralChat,
    initiateAppointmentChat,
    isActive: !!Object.keys(chat || {})?.length,
  }
}

export default useChatInitiater